import Typography from '../../typography';

export const DEFAULT_TEXT_STYLES = {
  rows: 1,
  tag: Typography.Tags.SPAN,
  variant: Typography.Variants.sm,
  color: Typography.Colors.gray500,
};
